import idx from "idx"
import { getSafeDataMap } from "@jsUtils/contentful"

const transform = data => {
  const investmentTeam = idx(data, _ => _.investors)
  const teams = getSafeDataMap(investmentTeam, i => {
    return {
      name: idx(i, _ => _.investorName),
      link: idx(i, _ => _.link),
      logo: idx(i, _ => _.logo),
      description: idx(i, _ => _.description),
      id: idx(i, _ => _.id)
    }
  })

  return {
    teams
  }
}

export default {
  transform
}
